export const getVisitorStatus = (): { is_returning_visitor: boolean } => {
  if (typeof window === 'undefined') return { is_returning_visitor: false }
  const isReturning = localStorage.getItem('rng_visited') === 'true'
  localStorage.setItem('rng_visited', 'true')
  return { is_returning_visitor: isReturning }
}
